import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import {reduxForm, FieldArray} from 'redux-form'
import {connect} from 'react-redux'
import {onCancelItemInventoryAlertModal} from 'actions/library/item'
import styles from './ItemInventoryAlertModal.css'
import ItemInventoryAlertModalFieldArray from './ItemInventoryAlertModalFieldArray'
import {Link} from 'react-router'

class ItemInventoryAlertModal extends React.Component {
  render () {
    const {showItemInventoryAlertModal, handleSubmit} = this.props
    return (<Modal show={showItemInventoryAlertModal} onHide={this._onCancel} dialogClassName={`modal-dialog ${styles.dialog}`}>
      <ModalHeader title={'Manage Inventory'} />
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <table className={`table table-responsive ${styles.table}`}>
            <thead>
              <tr>
                <th>Variant</th>
                <th>Track Stock</th>
                <th>In Stock</th>
                <th>Alert</th>
                <th>Alert at</th>
              </tr>
            </thead>
            <FieldArray
              component={ItemInventoryAlertModalFieldArray}
              name='item_variants'
              />
          </table>
        </Modal.Body>
        <Modal.Footer>
          <span className='pull-left'>
            <button className='btn btn-default' type='button' onClick={this._onCancel}>Cancel</button>
          </span>
          <span className='pull-right'>
            <button className='btn btn-primary' type='submit'>Confirm</button>
          </span>
          <i className={styles['footer-info']}>*Use the <Link to='/inventory/summary' target='blank'>Inventory page</Link> to manage stock</i>
        </Modal.Footer>
      </form>
    </Modal>)
  }

  _onCancel = () => {
    const {dispatch, previousItemForm} = this.props
    dispatch(onCancelItemInventoryAlertModal(previousItemForm))
  }
}

function mapStateToProps (state) {
  const {showItemInventoryAlertModal, previousItemForm} = state.library.item
  return {
    showItemInventoryAlertModal,
    previousItemForm
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'modal_item_variants',
  touchOnBlur: false,
  touchOnChange: false
}

export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(ItemInventoryAlertModal))



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemInventoryAlertModal/ItemInventoryAlertModal.js